import React, { useEffect, useState } from 'react'
import { Dropdown, Modal, Nav, Tab } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { AddUpdate } from '../../../../ApiMethods/ApiMethods';
import swal from 'sweetalert';
import DataTable from 'react-data-table-component';
import { customStyles } from '../../Utility/Utility';
import { get_PackageRoles, get_SinglePackageRoles, get_UserData } from '../../../../store/actions/CommanAction';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../Loader/Loader';
import Select from "react-select";

const PackageRoles = () => {
    const dispatch = useDispatch()

    const userdata = useSelector((state) => state.feedBackReducer.UserData);
   
    const userList = userdata?.map(({ UserID, NickName }) => ({
        UserID,
        NickName,
    }));
  
    const WalletData = useSelector((state) => state.feedBackReducer.GetDataPackageRoles);
    const WalletSingleData = useSelector((state) => state.feedBackReducer.GetSinglaDataPackageRoles);
    const [EditValue, setEditValue] = useState()
    const [IsActive, setIsActive] = useState(true);
    const [postModal, setPostModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [WalletPackageID, setWalletPackageID] = useState('')
    const [loading, setloading] = useState(false);
    const [startdate, setStartDate] = useState('');
    const [enddate, setEndDate] = useState('');
    const [targetType, setTargetType] = useState(null);
    const [bonusType, setBonusType] = useState(null);
    const [status, setStatus] = useState(true);
    const [walletPlanName, setWalletPlanName] = useState([])
    const [userOfferSuffix, setUserOfferSuffix] = useState("");

    

    const [Value, SetValue] = useState({
        'PackageName': '', 'RechargeCount': '', 'GSTInfo': '', 'TotalAmt': '', 'BonusInfo': '', 'CreatedTime': '', 'BonusValue': '', 'status': '', 'SubTotalAmt': '', 'CreatedByUser': '1',
        "minRechargeAmt": '', "maxRechargeAmt": '',"minvisibleRechargeAmt":''
    });
    useEffect(() => {
        if (IsActive) {
            dispatch(get_PackageRoles('1', setloading))
        } else {
            dispatch(get_PackageRoles('0', setloading))
        }
    }, [IsActive, IsActive]);


    const handleAddFormSubmit = async (event) => {
        event.preventDefault();
        let error = false;
        let errorMsg = '';

        
        if (Value.PackageName === "") {
            error = true;
            errorMsg = 'Please fill PackageName.';
        }
        if (startdate === "") {
            error = true;
            errorMsg = 'Please select StartDate.';
        }
        if (enddate === "") {
            error = true;
            errorMsg = 'Please select EndDate.';
        }
        if (status === "") {
            error = true;
            errorMsg = 'Please select Status.';
        }
        if (bonusType === null) {
            error = true;
            errorMsg = 'Please select BonusType.';
        }
        
        if (Value.BonusValue === "") {
            error = true;
            errorMsg = 'Please fill BonusValue.';
        }
      


        if (!error) {
          
            const postData = {
                'Name': Value?.PackageName,
                'RechargeCount': Value?.RechargeCount,
                'StartDate': startdate,
                'EndDate': enddate,
                'TargetType': targetType?.value || '',
                'BonusType': bonusType?.value || '',
                // 'Status': IsActive ? '1' : '0',
                'Status': status ? '1' : '0',


                'MinRechargeAmount': Value?.minRechargeAmt || 0,
                'MaxRechargeAmount': Value?.maxRechargeAmt || null,
                'MinRechargeVisibilityAmt': Value?.minvisibleRechargeAmt || 0,
                'BonusValue': Value?.BonusValue,
            }

            await AddUpdate('PackagesRules/Insert_PackagesRules', postData);
            setPostModal(false);
            dispatch(get_PackageRoles(IsActive, setloading));
            swal('Good job!', 'Successfully Added', "success");
            SetValue({ 'PackageName': '', 'RechargeCount': '', 'GSTInfo': '', 'TotalAmt': '', 'BonusInfo': '', 'CreatedTime': '', 'BonusValue': '', 'status': '', 'SubTotalAmt': '' });
        } else {
            swal('Oops', errorMsg, "error");
        }
    };

    const targetTypeOptions = [
        { value: "global", label: "Global" },
        { value: "segment", label: "Segment" },
        { value: "user", label: "User" }
    ];
    const bonustypsOptions = [
        { value: "percentage", label: "Percentage" },
        { value: "fixed", label: "Fixed" }
    ]


    const UpdateWallet = async (event) => {
        event.preventDefault();
        let error = false;
        let errorMsg = '';

        
        if (Value.PackageName === "") {
            error = true;
            errorMsg = 'Please fill PackageName.';
        }
        if (startdate === "") {
            error = true;
            errorMsg = 'Please select StartDate.';
        }
        if (enddate === "") {
            error = true;
            errorMsg = 'Please select EndDate.';
        }
        if (status === "") {
            error = true;
            errorMsg = 'Please select Status.';
        }
        if (bonusType === null) {
            error = true;
            errorMsg = 'Please select BonusType.';
        }
      
        if (Value.BonusValue === "") {
            error = true;
            errorMsg = 'Please fill BonusValue.';
        }
       


        if (!error) {
            const postData = {
                'Name': Value?.PackageName,
                'RechargeCount': Value?.RechargeCount,
                'StartDate': startdate,
                'EndDate': enddate,
                'TargetType': targetType?.value || '',
                'BonusType': bonusType?.value || '',
                // 'Status': IsActive ? '1' : '0',
                'Status': status ? '1' : '0',
                'MinRechargeAmount': Value?.minRechargeAmt || 0,
                'MinRechargeVisibilityAmt': Value?.minvisibleRechargeAmt || 0,
                'MaxRechargeAmount': Value?.maxRechargeAmt || null,
                'BonusValue': Value?.BonusValue,
                "OfferId": WalletPackageID
            }
        
            await AddUpdate('PackagesRules/UpDate_PackagesRules', postData);
            setPostModal(false);
            dispatch(get_PackageRoles(IsActive, setloading));
            swal('Good job!', 'Successfully Added', "success");
            SetValue({
                'PackageName': '', 'RechargeCount': '', 'GSTInfo': '', 'TotalAmt': '', 'BonusInfo': '', 'CreatedTime': '', 'BonusValue': '', 'status': '', 'SubTotalAmt': '', 'CreatedByUser': '1',
                "minRechargeAmt": '', "maxRechargeAmt": '',"minvisibleRechargeAmt":''
            });
            Reset(); setEditModal(false);

        } else {
            swal('Oops', errorMsg, "error");
        }
    };

    const Reset = () => {
        SetValue({
            ...Value,
            'PackageName': '', "minRechargeAmt": '', "minvisibleRechargeAmt":"","maxRechargeAmt": "", 'RechargeCount': '', 'GSTInfo': '', 'TotalAmt': '', 'BonusInfo': '', 'CreatedTime': '', 'BonusValue': '', 'status': '', 'SubTotalAmt': '',
        })
        setTargetType(null);
        setBonusType(null);
        setStartDate('');
        setEndDate('');

    }


    const handleChange = (e) => {
        const { name, value } = e.target;




        let updatedValue = { ...Value, [name]: value };

        SetValue(updatedValue);
    };



    const columns = [
        {
            name: 'Package Name', selector: (row) => row.Name, sortable: true,

        },
        
        {
            name: 'Recharge Count', selector: (row) => row.RechargeCount, sortable: true
        },

        {
            name: 'Bonus Amt', selector: (row) => row.BonusValue, sortable: true
        },
        {
            name: 'Bonus Type', selector: (row) => row.BonusType, sortable: true
        },
        {
            name: 'Start Date',
            selector: (row) =>
                row.StartDate ? new Date(row.StartDate).toLocaleDateString() : "-",
            sortable: true,
        },
        {
            name: 'End Date',
            selector: (row) =>
                row.EndDate ? new Date(row.EndDate).toLocaleDateString() : "-",
            sortable: true,
        }

        ,
        {
            name: <p className='text-end' style={{ position: 'absolute', top: '7px', right: 50 }}>Action</p>,
            cell: row => <>
                <div style={{ position: 'absolute', top: 4, right: 50 }}>
                    <Dropdown>
                        <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                            <Dropdown.Item onClick={() => handleEditClick(row)}>Edit</Dropdown.Item>
                            <Dropdown.Item
                                className={row.IsActive ? "text-danger" : "text-danger"}
                                onClick={() => {
                                    handleToggleStatusClick(row.OfferId, true, '0');
                                }}>
                                Delete
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </>
        }
    ]

    const columns1 = [
        {
            name: 'Package Name', selector: (row) => row.Name, sortable: true,

        },
      
        {
            name: 'Recharge Count', selector: (row) => row.RechargeCount, sortable: true
        },

        {
            name: 'Bonus Amt', selector: (row) => row.BonusValue, sortable: true
        },
        {
            name: 'Bonus Type', selector: (row) => row.BonusType, sortable: true
        },
        {
            name: 'Start Date',
            selector: (row) =>
                row.StartDate ? new Date(row.StartDate).toLocaleDateString() : "-",
            sortable: true,
        },
        {
            name: 'End Date',
            selector: (row) =>
                row.EndDate ? new Date(row.EndDate).toLocaleDateString() : "-",
            sortable: true,
        },
        {
            name: <p className='text-end' style={{ position: 'absolute', top: '7px', right: 50 }}>Action</p>,
            cell: row => <>
                <div style={{ position: 'absolute', top: 4, right: 50 }}>
                    <Dropdown>
                        <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                            <Dropdown.Item
                                className={row.IsActive ? "text-danger" : "text-success"}
                                onClick={() => {
                                    handleToggleStatusClick(row.OfferId, false, '1');
                                }}>
                                Active
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </>
        }
    ]

    useEffect(() => {
        setWalletPackageID(WalletPackageID); dispatch(get_SinglePackageRoles(WalletPackageID));
    }, [WalletPackageID])

    useEffect(() => {
        if (WalletSingleData) {
            setEditValue(WalletSingleData);
        }
    }, [WalletSingleData]);

    const handleEditClick = (row) => {
        dispatch(get_SinglePackageRoles(row?.OfferId)); setWalletPackageID(row?.OfferId);
        setEditValue(WalletSingleData); setEditModal(true);
    };
   
const handleToggleStatusClick = async (OfferId, currentStatus, isActiveValue) => {
    const postData = {
        OfferId: OfferId,
        IsActive: isActiveValue,
    };

    const confirmed = window.confirm("Are you sure you want to delete Rule?");
    if (!confirmed) return; 

    await AddUpdate('PackagesRules/Delete_PackagesRules', postData);
    dispatch(get_PackageRoles(currentStatus ? '1' : '0', setloading));
  
    swal('Good job!', `Successfully Deleted`, "success");
};


useEffect(() => {
    if (EditValue) {
        let pkgName = EditValue[0]?.Name;
        let suffix = "";
        if (pkgName?.startsWith("UserOffer") && pkgName.includes("-")) {
            suffix = pkgName.split("-")[1] || "";
            pkgName = "UserOffer";
        }
        setUserOfferSuffix(suffix);

        SetValue({
            ...Value,
            'WalletPackageID': WalletPackageID,
            'PackageName': pkgName,
            'GSTInfo': EditValue[0]?.GSTInfo,
            'TotalAmt': EditValue[0]?.TotalAmt,
            'BonusInfo': EditValue[0]?.BonusInfo,
            'BonusValue': EditValue[0]?.BonusValue,
            'SubTotalAmt': EditValue[0]?.SubTotalAmt,
            'CreatedTime': EditValue[0]?.CreatedTime,
            'minRechargeAmt': EditValue[0]?.MinRechargeAmount,
            'minvisibleRechargeAmt': EditValue[0]?.MinRechargeVisibilityAmt,
            "maxRechargeAmt": EditValue[0]?.MaxRechargeAmount,
            'RechargeCount':EditValue[0]?.RechargeCount
        });

      
        const cleanSuffix = suffix.replace(/['"]/g, "");
        setTargetType(cleanSuffix ? { value: cleanSuffix, label: cleanSuffix } : null);

        setBonusType(
            bonustypsOptions?.find(
                (option) => option?.value?.toLowerCase() === EditValue[0]?.BonusType?.toLowerCase()
            )
        );

        setStatus(Boolean(EditValue[0]?.Status));
        setStartDate(EditValue[0]?.StartDate ? new Date(EditValue[0]?.StartDate).toISOString().split('T')[0] : '');
        setEndDate(EditValue[0]?.EndDate ? new Date(EditValue[0]?.EndDate).toISOString().split('T')[0] : '');
    }
}, [EditValue]);



    const isActiveOptions = [
        { value: true, label: "True" },
        { value: false, label: "False" },
    ];


    const walletplanname = async () => {
        try {
            const res = await AddUpdate('WalletPlanName/GetData_WalletPlanName');
        
            const data = JSON.parse(res?.data?.data)
            const finaldata = data?.Table;
         
            setWalletPlanName(finaldata)
        } catch (error) {
            console.log("error", error)
        }
    }

    useEffect(() => {
        walletplanname()
        dispatch(get_UserData(setloading, 1))
    }, [])
   
    return (
        <>
            <h2 style={{ color: '#f7931e', fontWeight: 700 }}> Package Rules</h2>
            <Tab.Container defaultActiveKey="All">
                <div className="mt-4 d-flex justify-content-between align-items-center flex-wrap">
                    <div className="card-action coin-tabs mb-2">
                      
                    </div>
                    <Link to={"#"} className="btn btn-primary font-w600 mb-2 " onClick={() => { setPostModal(true); Reset() }}>+ New Package Rule</Link>
                </div>
                <div className="row ">
                    <div className="col-xl-12">
                        <div className="">
                            <div className=" p-0">
                                <Tab.Content>
                                    <Tab.Pane eventKey="All">
                                        <div className="mb-sm-5 d-flex flex-wrap align-items-center text-head">
                                            <Modal className="modal fade" show={postModal} onHide={() => setPostModal(false)} backdrop="static">
                                                <form>
                                                    <div className="modal-header">
                                                        <h4 className="modal-title fs-20">Add Package Rule</h4>
                                                        <button type="button" className="btn-close" onClick={() => setPostModal(false)} data-dismiss="modal"></button>
                                                    </div>
                                                    <div className="modal-body p-3">
                                                        <i className="flaticon-cancel-12 close" data-dismiss="modal"></i>
                                                        <div className="add-contact-box">
                                                            <div className="add-contact-content">
                                                                <div className="row">


                                                                    <div className="form-group mb-3 col-md-4">
                                                                        <label className="form-label">
                                                                            Package Name <span className="text-danger star-error">*</span>
                                                                        </label>
                                                                        <Select
                                                                            options={walletPlanName?.map((plan) => ({
                                                                                value: plan.PlanName,
                                                                                label: plan.PlanName,
                                                                            }))}
                                                                            className="react-select-box"
                                                                            styles={{
                                                                                control: (base) => ({
                                                                                    ...base,
                                                                                    height: "40px",
                                                                                    minHeight: "40px",
                                                                                    borderColor: "#f0ad4e",
                                                                                    boxShadow: "none",
                                                                                    "&:hover": { borderColor: "#f0ad4e" },
                                                                                }),
                                                                            }}
                                                                            value={
                                                                                walletPlanName
                                                                                    ?.map((plan) => ({ value: plan.PlanName, label: plan.PlanName }))
                                                                                    .find((option) => option.value === Value?.PackageName) || null
                                                                            }
                                                                            onChange={(selectedOption) =>
                                                                                handleChange({
                                                                                    target: { name: "PackageName", value: selectedOption?.value || "" },
                                                                                })
                                                                            }
                                                                            placeholder="Select "
                                                                            isSearchable={false}
                                                                        />
                                                                    </div>

                                                                    <div className="form-group mb-3 col-md-4">
                                                                        <label className="form-label">Recharge Count</label>

                                                                        <input type="number" name="RechargeCount" placeholder="Recharge Amt" required="required" className="form-control"
                                                                            maxLength={6}
                                                                            value={Value?.RechargeCount} onChange={handleChange}
                                                                            disabled={Value?.PackageName !== "RechargeCount"}
                                                                             style={{
                                                                      height: "40px", 
                                                                    backgroundColor: Value?.PackageName !== "RechargeCount" ? "#e9ecef" : "",
                                                                   cursor: Value?.PackageName !== "RechargeCount" ? "not-allowed" : "text",
                                                                           }}

                                                                        />
                                                                    </div>


                                                                     <div className="form-group mb-2 col-md-4">
                                                                        <label className="form-label">User List </label>
                                                                       
                                                                        <input type="number" name="TargetType" placeholder=" Enter User Id" required="required" className="form-control"
                                                                        value={targetType?.value} 
                                                                        onChange={(e) => setTargetType({value:e.target.value,label:e.target.value})}
                                                                        disabled={Value?.PackageName !== "UserOffer"}
                                                                       style={{
                                                                      height: "40px", 
                                                                    backgroundColor: Value?.PackageName !== "UserOffer" ? "#e9ecef" : "",
                                                                   cursor: Value?.PackageName !== "UserOffer" ? "not-allowed" : "text",
                                                                           }}
                                                                        
                                                                        />
                                                                    </div>

                                                                   

                                                                </div>
                                                                

                                                                <div className="row">
                                                                    <div className="form-group mb-2 col-md-6">
                                                                        <label className="form-label">Bonus Type <span className="text-danger star-error" >*</span></label>
                                                                        <Select
                                                                            options={bonustypsOptions}
                                                                            className="react-select-box"
                                                                            styles={{
                                                                                control: (base) => ({
                                                                                    ...base,
                                                                                    borderColor: "#f0ad4e",
                                                                                    boxShadow: "none",
                                                                                    "&:hover": { borderColor: "#f0ad4e" },
                                                                                }),
                                                                            }}
                                                                            value={bonusType}
                                                                            onChange={(selectedOption) => setBonusType(selectedOption)}
                                                                            placeholder="Select Bonus Type"
                                                                            isSearchable={false}
                                                                        />
                                                                    </div>
                                                                    <div className="form-group  col-md-6">
                                                                        <label className="form-label">Bonus Value <span className="text-danger star-error" >*</span></label>
                                                                        <input type="text" style={{ height: "40px" }} name="BonusValue" placeholder="Enter Bonus Value" className="form-control"
                                                                            maxLength={6}
                                                                            value={Value?.BonusValue} onChange={handleChange}
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="row">

                                                                    <div className="form-group  col-md-4">
                                                                        <label className="form-label">Min Recharge ₹ </label>
                                                                        <input type="number" style={{ height: "40px" }} name="minRechargeAmt" placeholder="Amount" className="form-control"
                                                                            maxLength={6}
                                                                            value={Value?.minRechargeAmt} onChange={handleChange}
                                                                        />
                                                                    </div>

                                                                    <div className="form-group  col-md-4">
                                                                        <label className="form-label">Max Recharge ₹ </label>
                                                                        <input type="number" style={{ height: "40px" }} name="maxRechargeAmt" placeholder="Amount" className="form-control"
                                                                            maxLength={6}
                                                                            value={Value?.maxRechargeAmt} onChange={handleChange}
                                                                        />
                                                                    </div>


                                                                <div className="form-group  col-md-4">
                                                                        <label className="form-label">MinRechargeVisible ₹</label>
                                                                        <input type="number" style={{ height: "40px" }} name="minvisibleRechargeAmt" placeholder="Amount" className="form-control"
                                                                            maxLength={6}
                                                                            value={Value?.minvisibleRechargeAmt} onChange={handleChange}
                                                                        />
                                                                    </div>


                                                                </div>

                                                                <div className="row">
                                                                    <div className="form-group mb-2 col-md-6">
                                                                        <label className="form-label" >Start Date <span className="text-danger star-error" >*</span></label>
                                                                        <input
                                                                            type="date"
                                                                            value={startdate}
                                                                            onChange={(e) => setStartDate(e.target.value)}
                                                                        />
                                                                    </div>
                                                                    <div className="form-group  col-md-6">
                                                                        <label className="form-label">End Date <span className="text-danger star-error" >*</span></label>
                                                                        <input type="date" value={enddate} onChange={((e) => setEndDate(e.target.value))} />
                                                                    </div>
                                                                </div>

                                                                <div className='row'>
                                                                     <div className="form-group mb-2 col-md-6">
                                                                        <label className="form-label">IsActive <span className="text-danger star-error" >*</span></label>
                                                                        <Select
                                                                            options={isActiveOptions}
                                                                            className="react-select-box"
                                                                            styles={{
                                                                                control: (base) => ({
                                                                                    ...base,
                                                                                    borderColor: "#f0ad4e",
                                                                                    boxShadow: "none",
                                                                                    "&:hover": { borderColor: "#f0ad4e" },
                                                                                }),
                                                                            }}
                                                                           value={isActiveOptions.find((option) => option.value === Boolean(status))}
                                                                           onChange={(selectedOption) => setStatus(selectedOption.value)}
                                                                            placeholder="Select status"
                                                                            isSearchable={false}
                                                                        />
                                                                    </div>
                                                                </div>



                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="modal-footer">
                                                        <button type="submit" className="btn btn-primary" onClick={handleAddFormSubmit}>Save</button>
                                                        <button type="button" onClick={() => { setPostModal(false); Reset('') }} className="btn btn-danger">
                                                            <i className="flaticon-delete-1"></i> Close
                                                        </button>
                                                    </div>
                                                </form>
                                            </Modal>
                                        </div>
                                        <Modal className="modal fade " show={editModal} onHide={setEditModal} backdrop="static">
                                            <div className="" role="document">
                                                <div className="">
                                                    <form >
                                                        <div className="modal-header">
                                                            <h4 className="modal-title fs-20">Edit Package Rules</h4>
                                                            <button type="button" className="btn-close" onClick={() => setEditModal(false)} data-dismiss="modal"></button>
                                                        </div>
                                                        <div className="modal-body p-3">
                                                            <i className="flaticon-cancel-12 close" data-dismiss="modal"></i>
                                                            <div className="add-contact-box">
                                                                <div className="add-contact-content">
                                                                    <div className="row">
                                                                        <div className="form-group mb-3 col-md-4">
                                                                        <label className="form-label">
                                                                            Package Name <span className="text-danger star-error">*</span>
                                                                        </label>
                                                                        <Select
                                                                            options={walletPlanName?.map((plan) => ({
                                                                                value: plan.PlanName,
                                                                                label: plan.PlanName,
                                                                            }))}
                                                                            className="react-select-box"
                                                                            styles={{
                                                                                control: (base) => ({
                                                                                    ...base,
                                                                                    height: "40px",
                                                                                    minHeight: "40px",
                                                                                    borderColor: "#f0ad4e",
                                                                                    boxShadow: "none",
                                                                                    "&:hover": { borderColor: "#f0ad4e" },
                                                                                }),
                                                                            }}
                                                                            value={
                                                                                walletPlanName
                                                                                    ?.map((plan) => ({ value: plan.PlanName, label: plan.PlanName }))
                                                                                    .find((option) => option.value === Value?.PackageName) || null
                                                                            }
                                                                            onChange={(selectedOption) =>
                                                                                handleChange({
                                                                                    target: { name: "PackageName", value: selectedOption?.value || "" },
                                                                                })
                                                                            }
                                                                            placeholder="Select Package"
                                                                            isSearchable={false}
                                                                        />
                                                                    </div>

                                                                       <div  className="form-group mb-2 col-md-4">
                                                                        <label className="form-label">User List </label>
                                                                         <input type="number" name="TargetType" placeholder=" Enter User Id" required="required" height={"80px"} className="form-control"
                                                                        value={targetType?.value} 
                                                                        onChange={(e) => setTargetType({value:e.target.value,label:e.target.value})}
                                                                        disabled={Value?.PackageName !== "UserOffer"}
                    
                                    
                                                                        style={{
                                                                      height: "40px", 
                                                                    backgroundColor: Value?.PackageName !== "UserOffer" ? "#e9ecef" : "",
                                                                   cursor: Value?.PackageName !== "UserOffer" ? "not-allowed" : "text",
                                                                           }}
                                                                        />
                                                                    </div>

                                                                    <div className="form-group mb-3 col-md-4">
                                                                        <label className="form-label">Recharge Count</label>

                                                                        <input type="number" name="RechargeCount" placeholder="Recharge Amt " required="required" height={"40px"} className="form-control"
                                                                            maxLength={6}
                                                                            value={Value?.RechargeCount} onChange={handleChange}
                                                                            disabled={Value?.PackageName !== "RechargeCount"}
                                                                      
                                                                               style={{
                                                                      height: "40px", 
                                                                    backgroundColor: Value?.PackageName !== "RechargeCount" ? "#e9ecef" : "",
                                                                   cursor: Value?.PackageName !== "RechargeCount" ? "not-allowed" : "text",
                                                                           }}
                                                                        />
                                                                    </div>


                                                                    </div>
                                                                    


                                                                    <div className="row">
                                                                        <div className="form-group mb-2 col-md-6">
                                                                            <label className="form-label">Bonus Type <span className="text-danger star-error" >*</span></label>
                                                                            <Select
                                                                                options={bonustypsOptions}
                                                                                className="react-select-box"
                                                                                styles={{
                                                                                    control: (base) => ({
                                                                                        ...base,
                                                                                        borderColor: "#f0ad4e",
                                                                                        boxShadow: "none",
                                                                                        "&:hover": { borderColor: "#f0ad4e" },
                                                                                    }),
                                                                                }}
                                                                                value={bonusType}
                                                                                onChange={(selectedOption) => setBonusType(selectedOption)}
                                                                                placeholder="Select Bonus Type"
                                                                                isSearchable={false}
                                                                            />
                                                                        </div>
                                                                        <div className="form-group  col-md-6">
                                                                            <label className="form-label">Bonus Value <span className="text-danger star-error" >*</span></label>
                                                                            <input type="text" style={{ height: "40px" }} name="BonusValue" placeholder="Enter Bonus Value" className="form-control"
                                                                                maxLength={6}
                                                                                value={Value?.BonusValue} onChange={handleChange}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="row">

                                                                        <div className="form-group  col-md-4">
                                                                            <label className="form-label">Min Recharge ₹ </label>
                                                                            <input type="number" style={{ height: "40px" }} name="minRechargeAmt" placeholder="Min Recharge Amount" className="form-control"
                                                                                maxLength={6}
                                                                                value={Value?.minRechargeAmt} onChange={handleChange}
                                                                            />
                                                                        </div>

                                                                        <div className="form-group  col-md-4">
                                                                            <label className="form-label">Max Recharge ₹ </label>
                                                                            <input type="number" style={{ height: "40px" }} name="maxRechargeAmt" placeholder="Amount" className="form-control"
                                                                                maxLength={6}
                                                                                value={Value?.maxRechargeAmt} onChange={handleChange}
                                                                            />
                                                                        </div>

                                                                   <div className="form-group  col-md-4">
                                                                        <label className="form-label">MinRechargeVisible ₹</label>
                                                                        <input type="number" style={{ height: "40px" }} name="minvisibleRechargeAmt" placeholder="Amount" className="form-control"
                                                                            maxLength={6}
                                                                            value={Value?.minvisibleRechargeAmt} onChange={handleChange}
                                                                        />
                                                                    </div>


                                                                    </div>

                                                                    <div className="row">
                                                                        <div className="form-group mb-2 col-md-6">
                                                                            <label className="form-label" >Start Date <span className="text-danger star-error" >*</span></label>
                                                                            <input
                                                                                type="date"
                                                                                value={startdate}
                                                                                onChange={(e) => setStartDate(e.target.value)}
                                                                            />
                                                                        </div>
                                                                        <div className="form-group  col-md-6">
                                                                            <label className="form-label">End Date <span className="text-danger star-error" >*</span></label>
                                                                            <input type="date" value={enddate} onChange={((e) => setEndDate(e.target.value))} />
                                                                        </div>
                                                                    </div>

                                                                    <div className='row'>
                                                                  <div className="form-group mb-2 col-md-6">
                                                                            <label className="form-label">IsActive <span className="text-danger star-error" >*</span></label>
                                                                            <Select
                                                                                options={isActiveOptions}
                                                                                className="react-select-box"
                                                                                styles={{
                                                                                    control: (base) => ({
                                                                                        ...base,
                                                                                        borderColor: "#f0ad4e",
                                                                                        boxShadow: "none",
                                                                                        "&:hover": { borderColor: "#f0ad4e" },
                                                                                    }),
                                                                                }}
                                                                                value={isActiveOptions.find((option) => option.value === status)}
                                                                                onChange={(selectedOption) => setStatus(selectedOption.value)}
                                                                                placeholder="Select status"
                                                                                isSearchable={false}
                                                                            />
                                                                        </div>

                                                                    </div>



                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="modal-footer">
                                                            <button type="submit" className="btn btn-primary" onClick={UpdateWallet}>Update</button>
                                                            <button type="button" onClick={() => { setEditModal(false); Reset() }} className="btn btn-danger"> <i className="flaticon-delete-1"></i> Close</button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </Modal>
                                        <div className="col-12 mt-2">
                                            {loading ? (
                                                <Loader />
                                            ) : (
                                                <DataTable
                                                    dense
                                                    data={WalletData}
                                                    columns={columns}
                                                    selectableRowsHighlight
                                                    pagination

                                                    fixedHeader
                                                    persistTableHead={true}
                                                    noDataComponent={"There are no data to display"}
                                                    customStyles={customStyles}
                                                />)}
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="Inactive">
                                        <div className="row">
                                            <div className="col-12 mt-2">
                                                {loading ? (
                                                    <Loader />
                                                ) : (
                                                    <DataTable
                                                        dense
                                                        data={WalletData}
                                                        columns={columns1}
                                                        selectableRowsHighlight
                                                        highlightOnHover
                                                        pagination

                                                        fixedHeader
                                                        persistTableHead={true}
                                                        customStyles={customStyles}

                                                        noDataComponent={"There are no data to display"}
                                                    />)}
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </div>
                    </div>
                </div >
            </Tab.Container >
        </>
    )
}

export default PackageRoles